export default ngModule => {
  ngModule.controller('ComparatorStep3CtrlAHB', function (      AonApplicationService,
      $log,
      $sce,
      $scope) {

    let ctrl = $scope.$parent.ctrl;

    // utility functino to check if "Credit Card" option has been selected
    ctrl.isCredit = function() {
      let currentTypes = ctrl.fieldsets.payment.type.choices;
      for (let t = 0; t < currentTypes.length; ++t) {
        if (currentTypes[t][0] == ctrl.application.payment.type
            && currentTypes[t][1].match(/credit/i))
        {
          return true;
        }
      }
      return false;
    }

    // track original set of payment frequency choices (dynamically change based on payment type)
    if (typeof(ctrl.fieldsets.payment.frequency.originalchoices) == 'undefined') {
      ctrl.fieldsets.payment.frequency.originalchoices = ctrl.fieldsets.payment.frequency.choices;
    }

    $scope.$watch('ctrl.application.payment.type', () => {

      // force datepicker onto 15th of the month
      let current = new Date(ctrl.application.payment.debit_date.getTime());
      let joinDate = new Date(ctrl.application.payment.join_date.getTime());
      let today = new Date();

      if (ctrl.isCredit()) {
        // if the current month, and we've pass the 15th, increment the month
        if (current.getMonth() <= today.getMonth()
            && today.getDate() > 15)
        {
            current.setMonth(current.getMonth() + 1);
        }
        // otherwise force current date to be the 15th
        current.setDate(15);
      } else {
        // TODO: better way to force calendar redraw
        current.setSeconds(joinDate.getSeconds()-1);
      }

      ctrl.application.payment.debit_date = current;

      // also drop Weekly or Fornightly options if credit card payment type
      if (!ctrl.isCredit()) {
        ctrl.fieldsets.payment.frequency.choices = ctrl.fieldsets.payment.frequency.originalchoices
      } else {
        let currentChoices = ctrl.fieldsets.payment.frequency.originalchoices;
        let adjustedChoices = [];
        for (let f = 0; f < currentChoices.length; ++f) {
          if (!currentChoices[f][1].match(/(Week|Fortnight)/)) {
            adjustedChoices.push(currentChoices[f]);
          }
        }
        ctrl.fieldsets.payment.frequency.choices = adjustedChoices;
      }
    });

    ctrl.debit_date_filter = function(date, mode) {
      // if day mode select AND credit card option selected
      return (mode == 'day' && ctrl.isCredit())
        ? (15 != date.getDate())
        : false;
    };
  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step3-ctrl-ahb.js